export function state() {
  return {
    all: [],
    selected: null,
    terminalPasswordPopup: {
      release: false,
      show: false,
    },
    employeeLoginPopup: {
      show: false,
    },
  }
}

export const mutations = {
  SET_ITEMS: (state, items) => (state.all = items),
  SET_SELECTED: (state, selected) => {
    state.selected = selected
  },
  SET_TERMINAL_PASSWORD_POPUP(state, payload) {
    state.terminalPasswordPopup = payload
  },
  SET_EMPLOYEE_LOGIN_POPUP(state, payload) {
    state.employeeLoginPopup = payload
  },
}

export const actions = {

  async fetch({ commit, dispatch }, slug) {
    try {
      dispatch('wait/start', 'terminals.index', { root: true })

      const { data } = await this.$axios.$get(`/terminals`, {
        headers: {
          'X-Company-Id': localStorage.getItem('company-id'),
          'x-location': slug,
        },
      })

      commit('SET_ITEMS', data)
    }
    catch (e) {
      console.log(e)
    }
    finally {
      dispatch('wait/end', 'terminals.index', { root: true })
    }
  },
  async lock({ commit, dispatch }, terminal) {
    try {
      // await dispatch('wait/start', 'terminals.lock', { root: true })
      const t = typeof terminal === 'string' ? JSON.parse(terminal) : terminal

      const id = t?.id
      if (!id)
        return false

      const res = await this.$axios.put(
        `/terminals/${id}/lock`,
        { token: t.token ?? null },
        {
          headers: {
            'X-Company-Id': localStorage.getItem('company-id'),
          },
        },
      )

      const { data: resTerminalData } = res.data
      const { terminal: updatedTerminal } = resTerminalData

      // const locationSlug = //rootGetters.currentLocation.slug
      await commit('SET_SELECTED', updatedTerminal)
      // await dispatch('fetch', locationSlug)
      return true
    }
    catch {
      console.log('terminal already in use')
      return false // important
    }
    finally {
      dispatch('wait/end', 'terminals.lock', { root: true })
    }
  },
  async check({ commit, getters }) {
    const { id, token } = getters.actualTerminal || {}

    if (!!id && token) {
      try {
        const { data } = await this.$axios.$post(
          `terminals/${id}/check`,
          { token },
          {
            headers: {
              'X-Company-Id': localStorage.getItem('company-id'),
            },
          },
        )

        commit('SET_SELECTED', { ...data, token })

        return Promise.resolve(true)
      }
      catch (e) {
        const hasError = e.response && e.response.status === 422

        if (hasError) {
          commit('SET_SELECTED', null)
        }

        return Promise.resolve(false)
      }
    }
    else {
      commit('SET_SELECTED', null)
      return Promise.resolve(false)
    }
  },
  async release({ rootGetters, dispatch }, terminal) {
    const { id } = terminal
    try {
      dispatch('wait/start', `terminals.release.${id}`, { root: true })

      const { token, password, hasLogout } = terminal

      const locationSlug = rootGetters.currentLocation ? rootGetters.currentLocation.slug : ''

      await this.$axios.$put(
        `terminals/${id}/release`,
        {
          token,
          password,
          hasLogout,
        },
        {
          headers: {
            'X-Company-Id': localStorage.getItem('company-id'),
          },
        },
      )

      await dispatch('fetch', locationSlug)

      await dispatch('clearSelectedTerminal')
      // return true so the swal message will close
      return true
    }
    catch {
      return false // needed
    }
    finally {
      dispatch('wait/end', `terminals.release.${id}`, { root: true })
    }
  },
  async selectAndLockTerminal({ dispatch }, { terminal, route }) {
    const lockStatus = await dispatch('lock', terminal)
    if (!lockStatus) {
      // Displays alert in front end
      return false
    }

    const { slug } = route.params

    await this.$auth.$storage.setUniversal('mode', null)
    await this.$auth.$storage.setUniversal('location_slug', slug)

    await dispatch('tickets/clearOpenedTickets', null, { root: true })

    this.$router.push(`/pos/0`) // async

    return true // necessary or the popup will show anyway in the pos screen
  },
  showPasswordPopupForRelease({ commit }, terminal) {
    commit('SET_TERMINAL_PASSWORD_POPUP', { show: true, release: true })
    commit('SET_SELECTED', terminal)
  },
  hidePasswordPopup({ commit }) {
    commit('SET_TERMINAL_PASSWORD_POPUP', { show: false })
  },
  showLoginPopup({ commit }, terminal) {
    commit('SET_EMPLOYEE_LOGIN_POPUP', { show: true })
    commit('SET_SELECTED', terminal)
  },
  hideLoginPopup({ commit }) {
    commit('SET_EMPLOYEE_LOGIN_POPUP', { show: false })
  },
  clearSelectedTerminal({ commit }) {
    commit('SET_SELECTED', null)
  },
}

export const getters = {
  enabledTerminals: state =>
    state.all.filter((terminal) => {
      return terminal.enabled
    }),
  actualTerminal: state => state.selected,
}
